<a
  class="link-out"
  [href]="href()"
  [target]="target()"
  [attr.rel]="target() === '_blank' ? 'noopener noreferrer' : null"
  [class.link-out--disabled]="disabled()">
  <app-icon
    class="link-out__icon"
    name="external-link"
    [size]="16"
    color="#1A1A1A">
  </app-icon>
  <span class="link-out__label">{{ label() }}</span>
</a>
